const UserSucc = () =>
  import('@/views/main/wechatMgmt/userSucc/UserSucc.vue')
export default {
  path: '/main/wechatMgmt/userSucc',
  name: 'UserSucc',
  component: UserSucc
}
